import React, { useEffect, useState } from "react";
import Appbar from "./Components/appbar";
import Menu from "./Components/Menu";
import Footer from "./Components/Footer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faDownload,
  faPlus,
  faSearch,
} from "@fortawesome/free-solid-svg-icons";
import "../style/ExpenseReport.css";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";
import { Link, useLocation } from "react-router-dom";
import jsPDF from "jspdf";
import "jspdf-autotable";

const convert = (str) => {
  var date = new Date(str),
    mnth = ("0" + (date.getMonth() + 1)).slice(-2),
    day = ("0" + date.getDate()).slice(-2);
  return [date.getFullYear(), mnth, day].join("-");
};

const FormatDate = (inp) => {
  let dateformat = inp.split("T")[0];
  const date = moment(dateformat, "YYYY-MM-DD");
  return date.format("DD-MMM-YYYY");
};

export default function ExpenseReport() {
  const location = useLocation();
  const passedState = location.state;

  const [TripClosureList, SetTripClosureList] = useState([]);
  const [ExpenseList, SetExpenseList] = useState([]);
  const [maintenanceList, setMaintenanceList] = useState([]);
  const [buses, setBuses] = useState([]);

  const [isDateInput, setIsDateInput] = useState([]);
  const [currenttime, setCurrenttime] = useState("");

  const DateTime = () => {
    const date = new Date();
    let y = date.toString();
    let todayDate = y.split(" ")[2];
    let thisMonth = y.split(" ")[1];
    let thisYear = y.split(" ")[3];
    let time = y.split(" ")[4];
    let noon = time.split(":")[0] >= 12 ? "PM" : "AM";
    let space = "  ";
    //   //console.log(y.split(" ")[2],y.split(" ")[1],y.split(" ")[3]," ",y.split(" ")[4],time.split(":")[0] >=12 ? "PM" : "AM");
    let final = (
      y.split(" ")[2] +
      "-" +
      y.split(" ")[1] +
      "-" +
      y.split(" ")[3] +
      " " +
      y.split(" ")[4] +
      " " +
      noon
    ).toString();
    setCurrenttime(final);
  };

  const InitState = {
    BusId: null,
    Start_Date: null,
    End_Date: null,
    user: passedState.username,
  };

  const [formData, setFormData] = useState(InitState);

  async function getBase64ImageFromUrl(url) {
    const response = await fetch(url);
    const blob = await response.blob();
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        //console.log(reader.result);
        resolve(reader.result);
      };
      reader.readAsDataURL(blob);
    });
  }

  const exportPDF = async () => {
    if (formData.Start_Date === null || formData.End_Date === null) {
      WarningMSG("Fill Date Feilds");
    } else {
      const doc = new jsPDF();
      var Y = 0;
      doc.setFontSize(16);
      doc.setTextColor("#4776E6");
      doc.text("Aathirran Travels", 85, (Y = Y + 10));
      doc.setTextColor("#000000");
      doc.setFontSize(8);
      doc.text(
        `From Date : ${
          formData.Start_Date ? FormatDate(formData.Start_Date) : null
        }`,
        20,
        (Y = Y + 10)
      );
      doc.text(`User : ${passedState.username}`, 140, Y);
      doc.text(
        `To Date : ${formData.End_Date ? FormatDate(formData.End_Date) : null}`,
        20,
        (Y = Y + 5)
      );
      doc.text(currenttime, 140, Y);
      doc.setFontSize(16);
      ExpenseList.length > 0
        ? doc.text("Expense Report", 85, (Y += 10))
        : doc.setFontSize(10);
      doc.autoTable({
        html: "#ExpenseTable",
        styles: { fontSize: 8 },
        startY: (Y = Y + 5),
      });
      doc.setFontSize(16);
      TripClosureList.length > 0
        ? doc.text(
            "Trip Expense Report",
            80,
            (Y += (ExpenseList.length / 4) * Y + 20)
          )
        : doc.setFontSize(10);
      doc.autoTable({
        html: "#TripExpenseTable",
        styles: { fontSize: 8 },
        startY: (Y = Y + 5),
      });
      doc.setFontSize(16);
      // if (maintenanceList.length > 0) {
      //   doc.text("Maintenance Report", 80, (Y += 20));
      //   doc.autoTable({
      //     html: "#MaintenanceTable",
      //     styles: { fontSize: 8 },
      //     startY: (Y = Y + 5),
      //   });
      //   doc.setFontSize(16);
      // }

      doc.save("table.pdf");
    }
  };

  const FetchBusList = async () => {
    const response = await axios.get(
      `${process.env.REACT_APP_API_BASE_URL}/bus/FetchBusList`,
      {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
        },
      }
    );
    setBuses(response.data);
  };

  useEffect(() => {
    const isText = Array(1).fill(false);
    setIsDateInput(isText);
    DateTime();
    // FetchBusList();
  }, []);

  const SuccessMSG = (msg) => {
    //console.log(msg)
    toast.success(msg, {
      position: "top-center",
      autoClose: 2000, // Auto-dismiss after 2 seconds
      hideProgressBar: true, // Optional: Hide progress bar
      closeOnClick: true, // Optional: Allow closing on click
      pauseOnHover: false, // Optional: Pause on hover
      draggable: false, // Optional: Disable dragging
    });
  };

  const WarningMSG = (msg) => {
    //console.log(msg)
    toast.warning(msg, {
      position: "top-center",
      autoClose: 2000, // Auto-dismiss after 2 seconds
      hideProgressBar: true, // Optional: Hide progress bar
      closeOnClick: true, // Optional: Allow closing on click
      pauseOnHover: false, // Optional: Pause on hover
      draggable: false, // Optional: Disable dragging
    });
  };
  const FailedMSG = (msg) => {
    //console.log(msg)
    toast.error(msg, {
      position: "top-center",
      autoClose: 2000, // Auto-dismiss after 2 seconds
      hideProgressBar: true, // Optional: Hide progress bar
      closeOnClick: true, // Optional: Allow closing on click
      pauseOnHover: false, // Optional: Pause on hover
      draggable: false, // Optional: Disable dragging
    });
  };

  const handleFocus = (index) => {
    const isText = [...isDateInput];
    isText[index] = true;
    setIsDateInput(isText);
  };

  const handleFocus1 = (index) => {
    const isText = [...isDateInput];
    isText[index] = false;
    setIsDateInput(isText);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleChangeDate = (e, index) => {
    const { name, value } = e.target;
    let date = new Date(e.target.value);
    //console.log((convert(date)))
    if (!isNaN(date)) {
      setFormData({
        ...formData,
        [name]: convert(date),
      });
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (formData.Start_Date === null || formData.End_Date === null) {
      WarningMSG("Fill Date Feilds");
    } else {
      try {
        console.log("formData:", formData);
        await axios
          .post(
            `${process.env.REACT_APP_API_BASE_URL}/tripclosure/ExpenseReport`,
            formData,
            {
              headers: {
                Authorization: `Bearer ${sessionStorage.getItem(
                  "access_token"
                )}`,
              },
            }
          )
          .then((res) => {
            if (res.status === 200) {
              console.log("report:", res.data);
              SetExpenseList(res.data.expense);
              SetTripClosureList(res.data.tripclosure);
              setMaintenanceList(res?.data?.maintance ?? []);
              if (
                res.data.expense.length === 0 &&
                res.data.tripclosure.length === 0 
              ) {
                WarningMSG("No Records Found");
              }
            } else {
              FailedMSG("Failed to Fetch");
            }
          })
          .catch((error) => {
            if (error.response && error.response.status !== 200)
              FailedMSG("Something went Wrong");
          });
      } catch (error) {
        if (error.response && error.response.status !== 200)
          FailedMSG("Something went Wrong");
      }
    }
  };
  let Expensetotal = 0;
  let TripExpenseTotal = 0;
  let maintenanceTotal = 0;
  let Total1 = 0;
  let Total2 = 0;

  return (
    <>
      <ToastContainer />
      <Appbar
        username={passedState.username}
        rights={passedState.rights}
      ></Appbar>
      <div className="ExpenseReport">
        <Menu
          username={passedState.username}
          rights={passedState.rights}
          i={"Report"}
        ></Menu>
        <div className="ExpenseReportPage">
          <p className="ExpenseReportHeadLabel">Expense Report</p>
          <div className="ExpenseReportHeaders">
            <div className="ExpenseReportRegSearch">
              <input
                placeholder="From Date"
                className="ExpenseReportFormInputs"
                type={isDateInput[0] ? "date" : "text"}
                onFocus={() => handleFocus(0)}
                onBlur={() => handleFocus1(0)}
                readOnly={!isDateInput[0]}
                value={
                  formData.Start_Date
                    ? FormatDate(formData.Start_Date)
                    : formData.Start_Date
                }
                onChange={(e) => handleChangeDate(e, 0)}
                name="Start_Date"
              ></input>
              <input
                placeholder="To Date"
                className="ExpenseReportFormInputs"
                type={isDateInput[1] ? "date" : "text"}
                onFocus={() => handleFocus(1)}
                onBlur={() => handleFocus1(1)}
                readOnly={!isDateInput[1]}
                value={
                  formData.End_Date
                    ? FormatDate(formData.End_Date)
                    : formData.End_Date
                }
                onChange={(e) => handleChangeDate(e, 1)}
                name="End_Date"
              ></input>
              {/* <select
                className="ExpenseReportFormInputs"
                name="BusId"
                value={formData.BusId}
                onChange={handleChange}
              >
                <option value="">Select Bus</option>
                {buses.length > 0
                  ? buses.map((bus, index) => (
                      <option key={index} name="BusId" value={bus.Bus_Id}>
                        {bus.Bus_Name}
                      </option>
                    ))
                  : null}
              </select> */}

              <button onClick={handleSubmit} className="ExpenseReportSearchBtn">
                <FontAwesomeIcon
                  className="ExpenseReportRegSearchIcon"
                  title="Search"
                  icon={faSearch}
                ></FontAwesomeIcon>
              </button>
            </div>
            <button
              className="NewExpenseReportBtn"
              title="Add New"
              onClick={exportPDF}
            >
              Export PDF
              <FontAwesomeIcon
                className="ExpenseReportAddNewIcon"
                icon={faDownload}
              ></FontAwesomeIcon>
            </button>
          </div>
          <div className="ExpenseReportLists">
            {ExpenseList.length > 0 ? (
              <>
                <t4 className="ExpenseReportLables">Expense Record</t4>
                <table id="ExpenseTable">
                  <thead>
                    <tr>
                      <td>Id/Reg No</td>
                      <td>Date</td>
                      <td>Reason</td>
                      <td>Amount</td>
                    </tr>
                  </thead>
                  <tbody>
                    {ExpenseList.map((items, i) => {
                      if (items.Amount != null) {
                        Expensetotal = Expensetotal + Number(items.Amount);
                      }
                      return (
                        <tr>
                          <td>{items.Expense_Id}</td>
                          <td>
                            {items.Date === null
                              ? "-"
                              : items.Date
                              ? FormatDate(items.Date)
                              : items.Date}
                          </td>
                          <td>
                            {items.Category === null ? "-" : items.Category}
                          </td>
                          <td>{items.Amount === null ? "-" : items.Amount}</td>
                        </tr>
                      );
                    })}
                    <tr>
                      <td></td>
                      <td></td>
                      <td>Total </td>
                      <td>{Expensetotal}</td>
                    </tr>
                  </tbody>
                </table>
              </>
            ) : null}
            {TripClosureList.length > 0 ? (
              <>
                <t4 className="ExpenseReportLables">Trip Expense</t4>
                <table id="TripExpenseTable">
                  <thead>
                    <tr>
                      <td>Booking Id</td>
                      <td>Araival Date</td>
                      <td>Customer Name</td>
                      <td>Register Number</td>
                      <td>Driver Salary</td>
                      <td>Fuel Charge</td>
                      <td>Repair Cost</td>
                      <td>Toll Charge</td>
                      <td>Additional Charge</td>
                      <td>Total Amount</td>
                    </tr>
                  </thead>
                  <tbody>
                    {TripClosureList.map((items, i) => {
                      if (items.Amount != null) {
                        TripExpenseTotal =
                          TripExpenseTotal + Number(items.Amount);
                      }
                      Total1 =
                        Number(items.Driver_Salary) +
                        Number(items.Fuel_Charges) +
                        Number(items.Repair_Cost) +
                        Number(items.Additional_Charges) +
                        Number(items.Toll_Charges);
                      //   Total1 = items.Driver_Salary === null ? 0 : Number(items.Driver_Salary)+ items.Fuel_Charges === null ?0:Number(items.Fuel_Charges)+items.Repair_Cost === null ?0:Number(items.Repair_Cost) + items.Toll_Charges === null ?0 :Number(items.Toll_Charges) ;
                      TripExpenseTotal = TripExpenseTotal + Total1;
                      return (
                        <tr>
                          <td>{items.Booking_Id}</td>
                          <td>
                            {items.Araival_Datetime === null
                              ? "-"
                              : items.Araival_Datetime
                              ? FormatDate(items.Araival_Datetime)
                              : items.Araival_Datetime}
                          </td>
                          <td>{items.Customer_Name}</td>
                          <td>{items.Register_Number}</td>
                          <td>
                            {items.Driver_Salary === null
                              ? "-"
                              : items.Driver_Salary}
                          </td>
                          <td>
                            {items.Fuel_Charges === null
                              ? "-"
                              : items.Fuel_Charges}
                          </td>
                          <td>
                            {items.Repair_Cost === null
                              ? "-"
                              : items.Repair_Cost}
                          </td>
                          <td>
                            {items.Toll_Charges === null
                              ? "-"
                              : items.Toll_Charges}
                          </td>
                          <td>
                            {items.Additional_Charges === null
                              ? "-"
                              : items.Additional_Charges}
                          </td>
                          <td>{Total1}</td>
                        </tr>
                      );
                    })}
                    <tr>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td>Total </td>
                      <td>{TripExpenseTotal}</td>
                    </tr>
                  </tbody>
                </table>
              </>
            ) : null}
            {/* {maintenanceList && maintenanceList.length > 0 ? (
              <>
                <t4 className="ExpenseReportLables">Maintenance Report</t4>
                <table id="ExpenseTable">
                  <thead>
                    <tr>
                      <td>Reg.no</td>
                      <td>Service Provider</td>
                      <td>MaintenanceDate</td>
                      <td>Reason</td>
                      <td>NextServiceDate</td>
                      <td>TotalAmount</td>
                    </tr>
                  </thead>
                  <tbody>
                    {maintenanceList.length > 0 &&
                      maintenanceList.map((items, i) => {
                        if (items.Total_Amount != null) {
                          maintenanceTotal =
                            maintenanceTotal + Number(items.Total_Amount);
                        }
                        return (
                          <tr>
                            <td>{items.Register_Number}</td>
                            <td>{items.Service_Provider}</td>
                            <td>
                              {items.Maintenance_Date === null
                                ? "-"
                                : items.Maintenance_Date
                                ? FormatDate(items.Maintenance_Date)
                                : items.Maintenance_Date}
                            </td>
                            <td>{items.Reason}</td>
                            <td>
                              {items.Next_Service_Date === null
                                ? "-"
                                : items.Next_Service_Date
                                ? FormatDate(items.Next_Service_Date)
                                : items.Next_Service_Date}
                            </td>
                            <td>
                              {items.Total_Amount === null
                                ? "-"
                                : items.Total_Amount}
                            </td>
                            
                          </tr>
                        );
                      })}
                    <tr>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td>Total </td>
                      <td>{maintenanceTotal}</td>
                    </tr>
                  </tbody>
                </table>
              </>
            ) : null} */}
            {((ExpenseList.length === 0) &&
            (TripClosureList.length === 0)) ? (
              <p>No Expense Found</p>
            ) : null}
          </div>
        </div>
      </div>
      <Footer></Footer>
    </>
  );
}
